import React from 'react';

/**
 * Error boundary (A6, auditoría 2026-10-02). Sin él, cualquier excepción al
 * pintar dejaba la pantalla en blanco y sin salida.
 *
 * Dos usos: alrededor de toda la app (`completa`, ocupa la ventana) y alrededor
 * del contenido de AppShell, con `key` = ruta, para que la barra superior siga
 * viva y navegar a otra sección limpie el error.
 */
export default class LimiteDeError extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[LimiteDeError]', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    // Tras un despliegue, una pestaña vieja pide trozos del bundle que ya no existen: recargar lo arregla.
    const trozoViejo = /Loading (CSS )?chunk|ChunkLoadError/i.test(String(error?.name) + String(error?.message));
    const boton = {
      borderRadius: 9999, padding: '11px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer', minHeight: 44,
    };
    return (
      <div
        role="alert"
        data-testid="limite-de-error"
        className="flex flex-1 flex-col items-center justify-center px-6 text-center"
        style={{ minHeight: this.props.completa ? '100vh' : 320, background: 'var(--bg)', color: 'var(--text)' }}
      >
        <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>Algo falló al mostrar esta pantalla</div>
        <p style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--text-2)', maxWidth: 380, marginBottom: 20 }}>
          {trozoViejo
            ? 'Orvian se actualizó mientras tenías la página abierta. Recarga para usar la versión nueva.'
            : 'Tu correo y tus archivos están bien: fue un error al pintar la página. Recarga para seguir; si se repite, avisa a quien administra el correo.'}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2">
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ ...boton, background: 'var(--accent)', color: '#fff', border: 0 }}
          >
            Recargar
          </button>
          <button
            type="button"
            onClick={() => window.location.assign('/mail')}
            style={{ ...boton, background: 'transparent', color: 'var(--text-2)', border: '1px solid var(--line-2)' }}
          >
            Ir a la bandeja
          </button>
        </div>
      </div>
    );
  }
}
